import React from "react";
import LoginPromptModal from "components/LoginPromptModal";
import useLanguageProvider from "components/LanguageProvider/hooks/useLanguageProvider";
import { useCommentContext } from "widgets/Comments/CommentContext";

import "./_style.scss";

import Default from "./components/Default";
import Thankyou from "./components/Thankyou";
import Existing from "./components/Existing";
import Authenticate from "./components/Authenticate";

const parseCommentText = (commentText) => {
  const doc = new DOMParser().parseFromString(commentText, "text/html");
  const parsedText = doc.body ? doc.body.textContent.trim() || "" : "";
  return parsedText.replace(/(?:\r\n|\r|\n)/g, "<br />");
};

const CommentModal = () => {
  const {
    campaignId,
    campaignTitle,
    campaignUpdateId,
    challengerId,
    captchaToken,
    commentModalStep: step,
    createComment,
    errorMessage,
    isCreating,
    isModalOpen,
    isRefreshing,
    isResendingLink,
    isResendLinkFail,
    isResendLinkSent,
    isSendingLink,
    pendingComment,
    pendingSubmit,
    replyToId,
    resendEmailLink,
    sendEmailLink,
    setModalStatus,
    setModalStep,
    signupEmail,
    signupName,
  } = useCommentContext();

  const { translate: t } = useLanguageProvider();

  const commentText = pendingSubmit?.content || "";
  const isAnonymous = Boolean(pendingSubmit?.anonymous);
  const parentCommentId = pendingSubmit?.reply_to_id ?? null;
  const isPosting = replyToId !== null ? false : isCreating;

  const handleSwitch = (type) => setModalStep(type);
  const handleClose = () => setModalStatus(false);

  const resendEmailHandler = (pendingCommentId) => {
    resendEmailLink({ campaign_id: campaignId, comment_id: pendingCommentId });
  };

  const sendEmailHandler = () => {
    sendEmailLink({
      campaign_id: campaignId,
      challenger_id: challengerId,
      content: commentText,
      email: signupEmail,
      name: signupName,
      reply_to_id: parentCommentId,
    });
  };

  const createCommentMarkup = () => ({
    __html: `&ldquo;${parseCommentText(commentText)}&rdquo;`,
  });

  const commonProps = {
    campaignId,
    campaignUpdateId,
    commentText,
    isAnonymous,
    createComment,
    challengerId,
    handleSwitch,
    errorMessage,
    isRefreshing,
    isPosting,
    parentCommentId,
    step,
    captchaToken,
  };

  const thankYouProps = {
    isResendingLink,
    isResendLinkFail,
    isResendLinkSent,
    pendingComment,
    resendEmailHandler,
  };

  return (
    <LoginPromptModal
      isOpen={isModalOpen}
      contentLabel={t("Signup/Login to post your comment")}
      onClose={handleClose}
    >
      {step === "default" && (
        <Default
          campaignTitle={campaignTitle}
          handleSwitch={handleSwitch}
          createCommentMarkup={createCommentMarkup}
        />
      )}

      {(step === "signup" || step === "login") && <Authenticate {...commonProps} />}

      {step === "thankyou" && <Thankyou thankYouProps={thankYouProps} />}

      {step === "existing" && (
        <Existing
          isSendingLink={isSendingLink}
          sendEmailHandler={sendEmailHandler}
          handleSwitch={handleSwitch}
        />
      )}
    </LoginPromptModal>
  );
};

export default CommentModal;
